import { PlusOutlined } from "@ant-design/icons";
import { Button, Checkbox, Divider, Form, Input, Modal } from "antd";
import { FormItemProps } from "antd/lib";
import { ReactElement, useState } from "react";
import { useParams } from "react-router-dom";
import { IField } from "../../../interfaces/IField";
import { useAppSelector } from "../../../store/reduxHooks";
import { SELECT_AGENT_BY_ID } from "../../../store/selectors/listAgentSelector";
import { UI_ITODatePicker } from "../../../UI_ITO/UI_ITODatePicker/UI_ITODatePicker";
import { RenderFields } from "../../../utils/HOC/RenderFields";

import classes from "./AdminAgentInfoMainForm.module.css";

export function AdminAgentMainForm(): ReactElement {
  const { id } = useParams();
  const findAgent = useAppSelector(SELECT_AGENT_BY_ID(id ? +id : undefined));
  const [modalOpen, setModalOpen] = useState(false);

  const isEditForm = useAppSelector(
    (state) => state.adminAgentInfoSlice.isEdit,
  );
  const infoOrganizationFields: IField[] = [
    {
      label: (
        <span className={classes.formItemLabel}>Наименование организации</span>
      ),
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>
          {findAgent?.organization?.name}
        </div>
      ),
      rules: [],

      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      label: <span className={classes.formItemLabel}>ИНН</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{findAgent?.organization?.inn}</div>
      ),
      rules: [],

      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      label: <span className={classes.formItemLabel}>ОГРН</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>
          {findAgent?.organization?.ogrn}
        </div>
      ),
      rules: [],

      rootClassName: classes.rootFormItem,
    },
    {
      label: <span className={classes.formItemLabel}>Почтовый адрес</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>
          {" "}
          {findAgent?.organization?.email}
        </div>
      ),
      rules: [],

      rootClassName: classes.rootFormItem,
    },

    {
      label: <span className={classes.formItemLabel}>Телефон</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>
          {findAgent?.organization?.phone_number}
        </div>
      ),
      rules: [],

      rootClassName: classes.rootFormItem,
    },
    {
      label: <span className={classes.formItemLabel}>КПП</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>123123123</div>
      ),
      rules: [],
      rootClassName: classes.rootFormItem,
    },
    {
      label: <span className={classes.formItemLabel}>Банк агента</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>123213</div>
      ),
      rules: [],
      rootClassName: classes.rootFormItem,
    },

    {
      label: <span className={classes.formItemLabel}>БИК банка</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>12321342143</div>
      ),
      rules: [],
      rootClassName: classes.rootFormItem,
    },
    {
      label: <span className={classes.formItemLabel}>Корр счет банка</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>1232413214</div>
      ),
      rules: [],
      rootClassName: classes.rootFormItem,
    },
    {
      label: (
        <span className={classes.formItemLabel}>Расчетный счет агента</span>
      ),
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>213321311</div>
      ),
      rules: [],
      rootClassName: classes.rootFormItem,
    },
  ];

  const contactInfoProps: FormItemProps[] = [
    {
      label: <span className={classes.formItemLabel}>Фамилия</span>,
      children: (
        <>
          {isEditForm ? (
            <Input size="large" />
          ) : (
            <div className={classes.fieldValue}>{findAgent?.surname}</div>
          )}
        </>
      ),
      rules: [],
      className: classes.formItem,
      name: "surname",
    },
    {
      label: <span className={classes.formItemLabel}>Имя</span>,
      children: (
        <>
          {isEditForm ? (
            <Input size="large" />
          ) : (
            <div className={classes.fieldValue}>{findAgent?.name}</div>
          )}
        </>
      ),
      rules: [],
      className: classes.formItem,
      name: "name",
    },
    {
      label: <span className={classes.formItemLabel}>Отчество</span>,
      children: (
        <>
          {isEditForm ? (
            <Input size="large" />
          ) : (
            <div className={classes.fieldValue}>{findAgent?.patronymic}</div>
          )}
        </>
      ),
      rules: [],
      className: classes.formItem,
      name: "patronymic",
    },
    {
      label: <span className={classes.formItemLabel}>Электронная почта</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{findAgent?.email}</div>
      ),
      rules: [],
      className: classes.formItem,
      name: "email",
    },
    {
      label: <span className={classes.formItemLabel}>Телефон</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{findAgent?.phone_number}</div>
      ),
      rules: [],
      className: classes.formItem,
      name: "phoneNumber",
    },
  ];

  const modalAddContactInfoFields: FormItemProps[] = [
    {
      label: <span>Фамилия</span>,
      children: <Input size="large" placeholder="Введите фамилию" />,
      rules: [],
      className: classes.formItem,
      name: "surname",
    },
    {
      label: <span>Имя</span>,
      children: <Input size="large" placeholder="Введите имя" />,
      rules: [],
      className: classes.formItem,
      name: "name",
    },
    {
      label: <span>Отчество</span>,
      children: <Input size="large" placeholder="Введите отчетство" />,
      rules: [],
      className: classes.formItem,
      name: "patronymic",
    },

    {
      label: <span>Телефон</span>,
      children: <Input size="large" placeholder="+7 999 999 99 99" />,
      rules: [],
      className: classes.formItem,
      name: "phone_number",
    },
  ];

  return (
    <>
      <Form
        id="changeAgentInfo"
        name="changeAgentInfo"
        className={classes.form}
        layout="vertical"
      >
        <div className={classes.pageAgentInfoWrapper}>
          <Divider
            orientation="left"
            orientationMargin="0"
            className={classes.pageAgentDivider}
          >
            Информация об агенте
          </Divider>

          <div className={classes.contactInfoContainer}>
            <div className={classes.fields}>
              {contactInfoProps.map((el) => {
                return <Form.Item {...el}>{el.children}</Form.Item>;
              })}
            </div>
          </div>
        </div>
        <div className={classes.pageAgentSectionInfo}>
          <Divider
            orientation="left"
            orientationMargin="0"
            className={classes.pageAgentDivider}
          >
            Контактное лицо
          </Divider>

          <div className={classes.contactInfoContainer}>
            <div className={classes.fields}>
              {contactInfoProps.map((el) => {
                return <Form.Item {...el}></Form.Item>;
              })}
            </div>

            <div>
              <Button
                size="large"
                iconPosition="start"
                icon={<PlusOutlined />}
                className={classes.pageAgentAddContact}
                onClick={() => setModalOpen(true)}
              >
                Добавить контактное лицо
              </Button>
            </div>
          </div>
        </div>

        <div className={classes.pageAgentSectionInfo}>
          <Divider
            orientation="left"
            orientationMargin="0"
            className={classes.pageAgentDivider}
          >
            Информация об организации
          </Divider>

          <div className={classes.organizationInfoContainer}>
            {RenderFields({ columns: infoOrganizationFields })}
          </div>

          <div className={classes.responsibleManager}>
            <Form.Item
              className={classes.formItem}
              label="Ответственный менеджер"
            >
              <Input size="large" />
            </Form.Item>
          </div>
        </div>

        <div className={classes.pageAgentSectionInfo}>
          <Divider
            orientation="left"
            orientationMargin="0"
            className={classes.pageAgentDivider}
          >
            Информация о договоре
          </Divider>

          <div className={classes.formContractInfo}>
            <Checkbox>Договор подписан</Checkbox>

            <div className={classes.contractInfoContainer}>
              <Form.Item className={classes.formItem} label="Номер договора">
                <Input size="large" />
              </Form.Item>

              <Form.Item className={classes.formItem} label="Дата договора">
                <UI_ITODatePicker className={classes.datePicker} />
              </Form.Item>
            </div>
          </div>
        </div>
      </Form>

      <Modal
        onCancel={() => setModalOpen(false)}
        footer
        open={modalOpen}
        width={700}
      >
        <div className={classes.modalTitle}>Добавить контактное лицо</div>
        <Form layout="vertical" className={classes.modalAddContactInfo}>
          {modalAddContactInfoFields.map((el) => {
            return (
              <Form.Item {...el} key={el.name}>
                {el.children}
              </Form.Item>
            );
          })}

          <div className={classes.modalFooter}>
            <Button size="middle" variant="solid" color={"primary"}>
              Добавить
            </Button>
            <Button
              onClick={() => {
                setModalOpen(false);
              }}
              size="middle"
              className={classes.cancelBtn}
            >
              Отменить
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
}
